import { defineStore } from 'pinia';
import { toRaw } from 'vue'
import _ from 'lodash';
import { useCustomerStore } from './customer';
import currencySettings from '../helpers/currencies.json';
// commit
export const useCurrenciesStore = defineStore('currencies', {
	state: () => ({
		currencies: null
	}),
	getters: {
		getKeypadValues(state) {
			if (state.getCurrencyCode == 'TOM') return [250000, 500000, 2500000]
			else if (state.getCurrencyCode == 'GHS') return [500, 1000, 5000]
			else return [5, 10, 20];
		},
		getKeypadValuesView(state) {
			if (state.getCurrencyCode == 'TOM') return [(250000).toLocaleString('de-DE'), (500000).toLocaleString('de-DE'), (2500000).toLocaleString('de-DE')]
			else if (state.getCurrencyCode == 'GHS') return [500, 1000, 5000]
			else return [5, 10, 20];
		},
		getCurrencies(state){
			return state.currencies
		},
		getSelectedCurrency(state) {
			const customerStore = useCustomerStore();
			if (customerStore.isLoggedIn) {
				return customerStore.getCustomer.currency
			}

			let default_currency = _.find(state.currencies, { 'default': true });

			return default_currency;
		},
		getCurrencyCode(state) {
			const customerStore = useCustomerStore();
			if (customerStore.isLoggedIn) {
				return customerStore.getCustomer.currency.code
			}

			let default_currency = _.find(state.currencies, { 'default': true });

			return default_currency.code;
		},
		getCurrencySymbol(state) {
			const customerStore = useCustomerStore();
			if (customerStore.isLoggedIn) {
				return customerStore.getCustomer.currency.symbol
			}

			let default_currency = _.find(state.currencies, { 'default': true });

			return default_currency.symbol;
		},
		getCurrencyCodeById: (state) => (currency_id) => {
			let currency = _.find(state.currencies, { 'id': currency_id });

			return currency.code;
		},
		format_currency: (state) => (amount, currency_code = null) => {
			if (isNaN(amount) || isNaN(parseFloat(amount))) return amount;

			if (currency_code == null) {
				currency_code = state.getCurrencyCode;
			}

			// Get currency from currency code or from logged in user
			let currency = currencySettings[currency_code];

			if (!currency_code) {
				var default_currency = _.find(toRaw(state.currencies), { 'default': true });

				if (_.isEmpty(default_currency)) return amount;

				currency = currencySettings[default_currency.code];
			}

			let format = '';
			if (currency.symbol_position == 'left') {
				format += currency.symbol;

				if (currency.space_between) format += ' ';
			}

			format += Number(amount).toFixed(currency.decimals)
				.replace(/\B(?=(\d{3})+(?!\d))/g, currency.thousands_separator)
				.replace('.', currency.decimal_separator);

			if (currency.symbol_position == 'right') {
				if (currency.space_between) format += ' ';

				format += currency.symbol;
			}

			return format;
		},
		format_number: (state) => (amount, currency_code = null) => {
			if (isNaN(amount) || isNaN(parseFloat(amount))) return amount;

			if (currency_code == null) {
				currency_code = state.getCurrencyCode;
			}

			// Get currency from currency code or from logged in user
			let currency = currencySettings[currency_code];

			if (!currency_code) {
				var default_currency = _.find(toRaw(state.currencies), { 'default': true });

				if (_.isEmpty(default_currency)) return amount;

				currency = currencySettings[default_currency.code];
			}

			let format = Number(amount).toFixed(currency.decimals)
			return format;
		},
		format_stake: (state) => (amount, currency_code = null) => {
			if (amount === '' || amount === null || amount === undefined) return '';

			if (currency_code == null) {
				currency_code = state.getCurrencyCode;
			}

			if (currency_code !== 'TOM') return amount;

			let currency = currencySettings[currency_code];
			if (!currency) return amount;

			const thousandsSeparator = currency.thousands_separator || ',';
			const decimalSeparator = currency.decimal_separator || '.';

			let parts = amount.toString().split('.');
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

			if (parts.length > 1) {
				return parts[0] + decimalSeparator + parts[1];
			}
			return parts[0];
		},
		sanitize_stake: (state) => (formatted_amount, currency_code = null) => {
			if (formatted_amount === '' || formatted_amount === null || formatted_amount === undefined) return '';

			if (currency_code == null) {
				currency_code = state.getCurrencyCode;
			}

			if (currency_code !== 'TOM') return formatted_amount;

			let currency = currencySettings[currency_code];
			if (!currency) return formatted_amount;

			const thousandsSeparator = currency.thousands_separator || ',';
			const decimalSeparator = currency.decimal_separator || '.';

			// Escape separator for regex if it's a dot
			const escapedThousands = thousandsSeparator === '.' ? '\\.' : thousandsSeparator;
			const escapedDecimal = decimalSeparator === '.' ? '\\.' : decimalSeparator;

			let sanitized = formatted_amount.toString().replace(new RegExp(escapedThousands, 'g'), '');
			sanitized = sanitized.replace(new RegExp(escapedDecimal, 'g'), '.');

			// Remove any characters that aren't digits or a decimal point
			sanitized = sanitized.replace(/[^0-9.]/g, '');

			// Ensure only one decimal point
			const firstDot = sanitized.indexOf('.');
			if (firstDot !== -1) {
				sanitized = sanitized.substring(0, firstDot + 1) + sanitized.substring(firstDot + 1).replace(/\./g, '');
			}

			return sanitized;
		},
	},
	actions: {
		setCurrencies(data) {
			this.currencies = data;
		}
	},
})